import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./MobileHeader.css";

const MobileHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setMenuOpen(!menuOpen);
    navigate("/login");
  };

  return (
    <header className="mobile-header">
      <div className="mobile-header-container">
        <div className="mobile-logo">
          <Link to="/" className="logo-link">
            <img src="/white-logo.png" alt="" />
          </Link>
        </div>
        <button
          className="menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle Menu"
        >
          ☰
        </button>
      </div>
      {menuOpen && (
        <nav className="mobile-menu">
          <ul className="mobile-menu-list">
            <li>
              <Link
                to="/"
                className="mobile-menu-item"
                onClick={() => setMenuOpen(!menuOpen)}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className="mobile-menu-item"
                onClick={() => setMenuOpen(!menuOpen)}
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="/blogs"
                className="mobile-menu-item"
                onClick={() => setMenuOpen(!menuOpen)}
              >
                Blogs
              </Link>
            </li>
            <li>
              <Link
                to="/posts"
                className="mobile-menu-item"
                onClick={() => setMenuOpen(!menuOpen)}
              >
                Posts
              </Link>
            </li>
            {user && user.role === "admin" && (
              <li>
                <Link
                  to="/dashboard"
                  className="mobile-menu-item"
                  onClick={() => setMenuOpen(!menuOpen)}
                >
                  Dashboard
                </Link>
              </li>
            )}
            {user ? (
              <li>
                <button
                  onClick={handleLogout}
                  className="mobile-menu-item logout-button"
                >
                  Logout
                </button>
              </li>
            ) : (
              <>
                <li>
                  <Link to="/login" className="mobile-menu-item">
                    Login
                  </Link>
                </li>
                <li>
                  <Link to="/register" className="mobile-menu-item">
                    Sign Up
                  </Link>
                </li>
              </>
            )}
          </ul>
        </nav>
      )}
    </header>
  );
};

export default MobileHeader;
